import * as React from 'react';
import { useParams } from 'react-router-dom';
import { IncidentWorkInjury } from '../_components/IncidentWorkInjury';
import { IncidentIssue } from '../_components/IncidentIssue';
import { IncidentAlmostAccident } from '../_components/IncidentAlmostAccident';
import { IncidentWhistleblower } from '../_components/IncidentWhistleblower';
import { IncidentType } from '../../../../amorg-common';
import { SingleColumnLayout } from '../../../../designSystem/layouts/SingleColumnLayout';
import { EmployeePageWrapper } from '../../../_pageWrappers/EmployeePageWrapper';

export function PortalIncidentPage(): JSX.Element
{
    return (
        <EmployeePageWrapper>
            <PortalIncidentPageContent />
        </EmployeePageWrapper>
    );
}

function PortalIncidentPageContent():JSX.Element
{

    const [incidentType, setIncidentType] = React.useState<IncidentType | null>(null);

    const params = useParams<{ type?: string }>();
    React.useEffect(() => {
        const typeParam = params.type;
        if (typeParam) {
            setIncidentType(typeParam as IncidentType);
        }
    }, [params.type]);

    return (
        <SingleColumnLayout
            noDivider
            contentContainer={

                
                <>
                    {incidentType !== null && incidentType === "issue" &&                         
                        <IncidentIssue />
                    }

                    {incidentType !== null && incidentType === "almost-accident" && 
                        <IncidentAlmostAccident />
                    }

                    {incidentType !== null && incidentType === "work-injury" && 
                        <IncidentWorkInjury />
                    }

                    {incidentType !== null && incidentType === "whistleblower" && 
                        <IncidentWhistleblower />
                    }
                </>
    
            } />
    );
}





